export default __webpack_public_path__ + "static/media/footer-underline.7a5f64de.svg";